<template>
  <UCard
    class="rounded-2xl"
    :class="maxClass"
    :ui="{ body: 'space-y-5 p-5 sm:p-6', footer: 'px-5 py-4 sm:px-6' }"
  >
    <div
      v-if="title || description"
      class="space-y-1"
    >
      <p
        v-if="title"
        class="font-semibold text-[var(--arad-text)]"
      >
        {{ title }}
      </p>
      <p
        v-if="description"
        class="text-sm text-[var(--ui-text-muted)]"
      >
        {{ description }}
      </p>
    </div>
    <slot />
    <template
      v-if="$slots.footer"
      #footer
    >
      <slot name="footer" />
    </template>
  </UCard>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    description?: string
    max?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
  }>(),
  {
    title: undefined,
    description: undefined,
    max: 'xl',
  },
)

const maxClass = computed(() => {
  const map = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    full: '',
  } as const
  return map[props.max]
})
</script>
